var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useId, useState } from "react";
import { DatagridConfigurable, FunctionField, List, useListContext, useRecordContext, } from "react-admin";
import { Box, Chip, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";
import { ENetworkDataPolicy, } from "@sequentech/ui-core";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useZonedEvent } from "@/providers/EventTimeZoneProvider";
import SelectElection from "@/components/election/SelectElection";
import { COUNTRIES } from "@/lib/countries";
import { FormStyles } from "@/components/styles/FormStyles";
import { ForensicExportActions } from "./ForensicExportActions";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { useContainerWidth } from "@/hooks/useContainerWidth";
import { AdminDateTime } from "@/components/AdminDateTime";
import { IPermissions } from "@/types/keycloak";
import { ForensicAddressDialog } from "./ForensicAddressDialog";
import { ForensicPseudonym, ForensicCountry, ForensicBallotCount, ForensicAddressButton, } from "./ForensicFields";
var Empty = function () {
    var t = useTranslation().t;
    return (_jsxs(Stack, { alignItems: "center", spacing: 1, sx: { py: 6, px: 3, textAlign: "center" }, children: [_jsx(LanguageIcon, { sx: { fontSize: 36, color: "text.secondary" } }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: t("ballotPrivacy.forensic.emptyList") })] }));
};
var SelectedForensicAddress = function (_a) {
    var electionEventId = _a.electionEventId, electionId = _a.electionId, selected = _a.selected, onClose = _a.onClose;
    var filterValues = useListContext().filterValues;
    var aliasRenderer = useAliasRenderer();
    var t = useTranslation().t;
    var effectiveElectionId = electionId !== null && electionId !== void 0 ? electionId : filterValues.election_id;
    return selected ? (_jsx(ForensicAddressDialog, { electionEventId: electionEventId, electionId: effectiveElectionId, ip: selected.ip, shared: selected.shared, electionLabel: selected.election_presentation
            ? aliasRenderer(selected.election_presentation)
            : t("ballotPrivacy.forensic.allElections"), onClose: onClose }, "".concat(effectiveElectionId !== null && effectiveElectionId !== void 0 ? effectiveElectionId : "all", ":").concat(selected.ip))) : null;
};
var AddressActions = function (_a) {
    var row = _a.row, onOpen = _a.onOpen;
    var t = useTranslation().t;
    var _b = useState(null), anchor = _b[0], setAnchor = _b[1];
    var _c = useState(false), copyError = _c[0], setCopyError = _c[1];
    var copy = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setAnchor(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(row.ip)];
                case 2:
                    _b.sent();
                    setCopyError(false);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    setCopyError(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { size: "small", "aria-label": t("common.label.actions"), onClick: function (event) {
                    event.stopPropagation();
                    setAnchor(event.currentTarget);
                }, children: _jsx(MoreVertIcon, {}) }), _jsxs(Menu, { anchorEl: anchor, open: !!anchor, onClose: function () { return setAnchor(null); }, children: [_jsx(MenuItem, { onClick: function () {
                            setAnchor(null);
                            onOpen();
                        }, children: t("ballotPrivacy.forensic.view") }), _jsx(MenuItem, { onClick: function () { return void copy(); }, children: t("ballotPrivacy.forensic.copy") })] }), copyError && (_jsx(Typography, { variant: "caption", color: "error", children: row.ip }))] }));
};
export var ListIpAddress = function (_a) {
    var _b;
    var aside = _a.aside;
    var t = useTranslation().t;
    var titleId = useId();
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var auth = useContext(AuthContext);
    var aliasRenderer = useAliasRenderer();
    var record = useRecordContext();
    var event = useZonedEvent();
    var electionEventId = (_b = record === null || record === void 0 ? void 0 : record.election_event_id) !== null && _b !== void 0 ? _b : record === null || record === void 0 ? void 0 : record.id;
    var electionId = (record === null || record === void 0 ? void 0 : record.election_event_id) ? record.id : undefined;
    var presentation = ((record === null || record === void 0 ? void 0 : record.election_event_id) ? event === null || event === void 0 ? void 0 : event.presentation : record === null || record === void 0 ? void 0 : record.presentation);
    var _c = useState(), selected = _c[0], setSelected = _c[1];
    var _d = useContainerWidth(), ref = _d[0], width = _d[1];
    var compact = width !== null && width < 1000;
    var pseudonymLimit = width !== null && width < 600 ? 1 : 2;
    var preferenceKey = "forensic_network.".concat(electionId ? "election" : "event", ".").concat(compact ? "compact" : "table");
    var canRead = auth.isAuthorized(true, tenantId, IPermissions.FORENSIC_READ);
    if (!electionEventId ||
        !canRead ||
        (presentation === null || presentation === void 0 ? void 0 : presentation.network_data_policy) !== ENetworkDataPolicy.FORENSIC_STORE)
        return null;
    var preview = function (row) {
        var _a, _b, _c, _d;
        return (_jsxs(Stack, { direction: "row", useFlexGap: true, flexWrap: "wrap", gap: 0.5, children: [((_a = row.pseudonyms) !== null && _a !== void 0 ? _a : []).slice(0, pseudonymLimit).map(function (pseudonym) { return (_jsx(ForensicPseudonym, { code: pseudonym }, pseudonym)); }), ((_b = row.pseudonym_count) !== null && _b !== void 0 ? _b : (_c = row.pseudonyms) === null || _c === void 0 ? void 0 : _c.length) > pseudonymLimit && (_jsx(Typography, { variant: "caption", color: "#0F054C", sx: { alignSelf: "center", whiteSpace: "nowrap", fontWeight: 600 }, children: t("ballotPrivacy.forensic.more", {
                        count: ((_d = row.pseudonym_count) !== null && _d !== void 0 ? _d : row.pseudonyms.length) - pseudonymLimit,
                    }) }))] }));
    };
    return (_jsxs(Box, { ref: ref, component: "section", "aria-labelledby": titleId, className: "print-hidden forensic-network-panel", sx: { width: "100%", minWidth: 0, maxWidth: "100%", mt: 3 }, children: [_jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "flex-start", useFlexGap: true, flexWrap: "wrap", gap: 1, sx: { mb: 1 }, children: [_jsxs(Box, { sx: { minWidth: 0 }, children: [_jsx(Typography, { component: "h2", variant: "h5", id: titleId, sx: { fontWeight: 600, fontSize: 24 }, children: t("dashboard.ipAddress.title") }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 0.5 }, children: t("ballotPrivacy.forensic.subtitle") })] }), _jsx(Chip, { size: "small", icon: _jsx(LockOutlinedIcon, {}), label: t("ballotPrivacy.forensic.store"), sx: {
                            "height": 26,
                            "borderRadius": "100px",
                            "fontSize": 12,
                            "fontWeight": 500,
                            "color": "#0F054C",
                            "bgcolor": "#F1F0FA",
                            "& .MuiChip-icon": { fontSize: 15, color: "inherit" },
                        } })] }), _jsxs(List, { resource: "ip_address", queryOptions: { refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS }, filter: __assign({ tenant_id: tenantId, election_event_id: electionEventId }, (electionId ? { election_id: electionId } : {})), storeKey: false, aside: aside, empty: _jsx(Empty, {}), filters: __spreadArray([
                    _jsx(FormStyles.TextInput, { source: "ip", label: t("dashboard.ipAddress.ip") }, "ip"),
                    _jsx(FormStyles.AutocompleteInput, { source: "country", label: t("dashboard.ipAddress.country"), choices: COUNTRIES, optionValue: "code" }, "country")
                ], (!electionId
                    ? [
                        _jsx(SelectElection, { source: "election_id", label: t("dashboard.ipAddress.ElectionName"), tenantId: tenantId, electionEventId: electionEventId }, "election"),
                    ]
                    : []), true), actions: _jsx(ForensicExportActions, { electionEventId: electionEventId, electionId: electionId, preferenceKey: preferenceKey }), sx: {
                    "minWidth": 0,
                    "& .RaList-main": { minWidth: 0 },
                    "& .RaList-content": {
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                        boxShadow: "none",
                    },
                    "& .RaFilterForm-form": { flexWrap: "wrap", minWidth: 0 },
                    "& .RaFilterForm-filterFormInput": { maxWidth: "100%", minWidth: 0 },
                    "& .RaList-actions": { flexWrap: "wrap", p: 0, mb: 2, gap: 1 },
                    "& .RaList-actions > form": { flex: "1 1 auto", minHeight: 0, p: 0, m: 0 },
                    "& .RaList-actions > .list-actions": { ml: "auto", maxWidth: "100%" },
                    "& .RaList-actions .MuiToolbar-root": {
                        minHeight: 0,
                        p: 0,
                        borderRight: 0,
                        gap: 0,
                    },
                    "& .RaList-actions .MuiButton-root": {
                        "bgcolor": "transparent",
                        "color": "#0F054C",
                        "border": "1px solid",
                        "borderColor": "#0F054C",
                        "borderRadius": 0,
                        "minHeight": 36,
                        "minWidth": 36,
                        "textTransform": "uppercase",
                        "fontSize": 12,
                        "fontWeight": 500,
                        "&:hover": { bgcolor: "action.hover" },
                        "& + .MuiButton-root": { borderLeft: 0 },
                    },
                    "& .MuiToolbar-root:last-child": { borderRight: 0 },
                    "& .MuiToolbar-root": { flexWrap: "wrap", gap: 0.5 },
                    "& .RaDatagrid-table": { tableLayout: "fixed", width: "100%" },
                    "& .RaDatagrid-headerCell": {
                        bgcolor: "background.paper",
                        color: "text.secondary",
                        fontWeight: 600,
                        py: 1,
                    },
                    "& .RaDatagrid-rowCell": {
                        overflowWrap: "anywhere",
                        py: compact ? 2 : 1.5,
                        verticalAlign: "middle",
                    },
                    "& .RaDatagrid-checkbox": { width: 42, p: 0 },
                    "& .MuiCheckbox-root": { width: 36, height: 36, p: 0 },
                    "& td.MuiTableCell-paddingCheckbox, & th.MuiTableCell-paddingCheckbox": {
                        width: 42,
                        px: 1,
                        py: 0,
                    },
                    "& .column-ip": { width: compact ? "auto" : "18%" },
                    "& .column-country": { width: 80 },
                    "& .column-vote_count": { width: 130, textAlign: "right" },
                    "& .column-election_presentation": { width: "16%" },
                    "& .column-first_ballot, & .column-last_ballot": { width: "19%" },
                    "& .column-actions": { width: 56, textAlign: "right" },
                    "& .RaPagination-root": { px: 1 },
                }, children: [_jsxs(DatagridConfigurable, { preferenceKey: preferenceKey, omit: compact ? [] : ["first_ballot", "election_presentation"], bulkActionButtons: _jsx(ForensicExportActions, { electionEventId: electionEventId, electionId: electionId, selectedOnly: true }), children: [compact ? (_jsx(FunctionField, { source: "ip", sortable: false, label: t("ballotPrivacy.forensic.address"), render: function (row) { return (_jsxs(Stack, { spacing: 1, children: [_jsxs(Stack, { direction: "row", alignItems: "flex-start", justifyContent: "space-between", spacing: 1, children: [_jsx(ForensicAddressButton, { ip: row.ip, onOpen: function () { return setSelected(row); } }), _jsx(ForensicBallotCount, { count: row.vote_count, shared: row.shared })] }), _jsxs(Stack, { direction: "row", alignItems: "center", useFlexGap: true, flexWrap: "wrap", gap: 1, children: [_jsx(ForensicCountry, { code: row.country, showName: true }), _jsx(Typography, { variant: "body2", children: _jsx(AdminDateTime, { value: row.last_ballot, event: electionEventId, seconds: true }) })] }), preview(row)] })); } })) : ([
                                _jsx(FunctionField, { source: "ip", sortable: false, label: t("ballotPrivacy.forensic.address"), render: function (row) { return (_jsx(ForensicAddressButton, { ip: row.ip, onOpen: function () { return setSelected(row); } })); } }),
                                _jsx(FunctionField, { source: "country", sortable: false, label: t("dashboard.ipAddress.country"), render: function (row) { return (_jsx(ForensicCountry, { code: row.country })); } }),
                                _jsx(FunctionField, { source: "vote_count", sortable: false, label: t("ballotPrivacy.forensic.ballots"), render: function (row) { return (_jsx(ForensicBallotCount, { count: row.vote_count, shared: row.shared })); } }),
                                _jsx(FunctionField, { source: "election_presentation", sortable: false, label: t("dashboard.ipAddress.ElectionName"), render: function (row) {
                                        return row.election_presentation
                                            ? aliasRenderer(row.election_presentation)
                                            : t("ballotPrivacy.forensic.allElections");
                                    } }),
                                _jsx(FunctionField, { source: "pseudonyms", sortable: false, label: t("ballotPrivacy.forensic.pseudonyms"), render: preview }),
                                _jsx(FunctionField, { source: "first_ballot", sortable: false, label: t("ballotPrivacy.forensic.first"), render: function (row) { return (_jsx(AdminDateTime, { value: row.first_ballot, event: electionEventId, seconds: true })); } }),
                                _jsx(FunctionField, { source: "last_ballot", sortable: false, label: t("ballotPrivacy.forensic.last"), render: function (row) { return (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { fontSize: 12, lineHeight: 1.7 }, children: _jsx(AdminDateTime, { value: row.last_ballot, event: electionEventId, seconds: true }) })); } }),
                            ]), _jsx(FunctionField, { source: "actions", sortable: false, label: t("common.label.actions"), render: function (row) { return (_jsx(AddressActions, { row: row, onOpen: function () { return setSelected(row); } })); } })] }, compact ? "compact" : "table"), _jsx(SelectedForensicAddress, { electionEventId: electionEventId, electionId: electionId, selected: selected, onClose: function () { return setSelected(undefined); } })] })] }));
};
